import angular from 'angular';
import editTrainingWebinarDirective from './edit-webinar.directive';
import message from './webinar-thumbnail.messages.html';


export default angular.module('app.components.admin.trainingAdministration.media.editMedia.editWebinarDialog', [])
  .directive('editTrainingWebinar', editTrainingWebinarDirective)
  .controller('EditTrainingWebinarDirectiveController', () => { /* here to provide controllerAs vm */ })
  .run(($templateCache) => {
    $templateCache.put('webinar-thumbnail.messages.html', message);
  })
  .name;

console.log('app.components.admin.trainingAdministration.media.editMedia.editWebinarDialog created');
